import { blogPosts, type BlogPost } from "@/data/blogPosts";

export type { BlogPost };

/** Returns posts sorted by date descending (newest first). */
export function getAllPosts(): BlogPost[] {
  return [...blogPosts].sort((a, b) => (a.date < b.date ? 1 : -1));
}

export function getPostBySlug(slug: string): BlogPost | undefined {
  return blogPosts.find((p) => p.slug === slug);
}

/** Reading time in minutes (rounded up, min 1). 200 WPM. */
export function getReadingMinutes(body: string): number {
  const words = (body || "").trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(words / 200));
}

export function formatDateDE(iso: string): string {
  try {
    return new Date(iso).toLocaleDateString("de-DE", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

/** Related posts: same category first, then most recent others. Excludes current. */
export function getRelatedPosts(currentSlug: string, limit = 3): BlogPost[] {
  const current = getPostBySlug(currentSlug);
  const all = getAllPosts().filter((p) => p.slug !== currentSlug);
  if (!current) return all.slice(0, limit);
  const sameCat = all.filter((p) => p.category === current.category);
  const others = all.filter((p) => p.category !== current.category);
  return [...sameCat, ...others].slice(0, limit);
}
